import React, {useState} from 'react';

const Header = () => {
    return (
        <div className="m-5 text-white">
            <h3>Stories borrowed to develop the webiste:</h3>
            <ul>
                <li>https://www.hauntedrooms.co.uk/5-short-true-ghost-stories</li>
                <li>- https://www.hauntedrooms.co.uk/5-short-true-ghost-stories
- https://www.reddit.com/r/nosleep/comments/ll8kq7/my_uncle_left_me_a_shifty_little_bar_in_his_will/</li>
                <li>https://www.reddit.com/r/nosleep/comments/llv27d/my_brother_didnt_leave_his_room_for_three_days_my/</li>
            </ul>
        </div>
    );
};

export default Header;